module.exports = __webpack_public_path__ + "static/media/slider1-4.43fbe136.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/Home/slider1-4.jpg
// module id = 478
// module chunks = 0